import { createAppSlice } from '../../app/createAppSlice'

const initialState = {on: false, olderVersionFhirString: ""};

const viewingOlderVersionSlice = createAppSlice({
    name: "viewingOlderVersion",
    initialState,
    reducers: create => ({
        viewingOlderVersionOn: create.reducer((state) => { state.on = true; }),
        viewingOlderVersionOff: create.reducer((state) => { state.on = false; }),
        changeOlderVersionFhirString: create.reducer((state, action) => {
                 state.olderVersionFhirString = action.payload
        })
    }),
    selectors: {
        selectViewingOlderVersion: viewingOlderVersion => viewingOlderVersion.on,
        selectOlderVersionFhirString: viewingOlderVersion => viewingOlderVersion.olderVersionFhirString
    },
})

export const { viewingOlderVersionOn, viewingOlderVersionOff, changeOlderVersionFhirString } = viewingOlderVersionSlice.actions

export const { selectViewingOlderVersion, selectOlderVersionFhirString } = viewingOlderVersionSlice.selectors

export default viewingOlderVersionSlice